import styled from 'styled-components'

const Container = styled.div`
 max-width: 767px;
 width: 100%;
 min-height: 350px;
`

const Body = styled.div``
const ActionBtn = styled.div`
            display: flex;
            justify-content: flex-end;
            // margin-top: 100px;
            border-top: 1px solid #9797971c;
    padding: 20px 0;
            > button {
                    height: 40px;
            width: 140px;
            margin-left: 15px;  
            }
`
const Location = styled.div`
    h6 {
        text-align:left;
        padding-top: 5px;

        a{color: #0a5587 !important}
    }
    .titleColour{
      color: #0a5587 !important;
    }
    .pTag{
      margin: 7px 0 !important;
      display: flex;
    }
    .Lots{
      margin:0 !important;
    }
    .css-g1d714-ValueContainer{
      max-height: 110px  !important;
      overflow: auto !important;
    }
    .css-1okebmr-indicatorSeparator{
      background-color:none;
    }
    .select__control{
      max-height: 110px !important;
      overflow: auto !important;
    }

    .select__menu{
      max-height:83px !important;
      overflow: auto !important;
      // padding-bottom: 20px !important;
    }
    .select__menu-list {
      max-height: 83px !important;
    }
    .app-input-text.number-format-input-styles{
      margin-bottom: 0px !important;
      display: inline;
    }
    .app-input-text input{
      max-width: 260px !important;
    }
    .section-separator-line{
      border-bottom: 1px solid #d2cfcf;
    }
    .edit-section button{
      display: inline !important
    }
    .edit-section button img{
      max-width: 22px;
      margin-bottom: 6px;
    }
    .recurring-post-title{
      width: 210px;
      overflow: hidden;
      display: inline-flex;
      min-width: 160px;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
      p.titleColour{
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .label-col-50{
      width: 135px;
      min-width: 135px;
      max-width: 135px;
      position: relative;
      > p:after{
        content: ":";
        right: 15px;
        position: absolute;
      }
    }
    @media (max-width: 465px){
      .app-input-text input{
        max-width: 245px !important;
      }
    }
`
const Categories = styled.div`
  h6 {
    text-align: left;
  }
  .xIcon {
    position: absolute;
    right: -24px;
    top: 11px;
    width: 18px;
    opacity: 0.5;
  }
  @media (max-width: 767px) {
    .blank-space {
      display: none;
    }
  }
`;

const InfoTitleText = styled.div`
  font-size:14px !important;
  text-align:center !important;
  line-height: 18px !important;
`

export { Container, Body, ActionBtn, Location, Categories, InfoTitleText};